// extracted by mini-css-extract-plugin
export var text = "_ao-0";